import { t } from "@/i18n-js/instance";
import { planFeatures } from "@/react/helpers/plansHelpers";

import { FeatureCell } from "./FeatureCell";
import { NumberFeature } from "./NumberFeature";
import { StringFeature } from "./StringFeature";
import { TooltipIcon } from "./TooltipIcon";

const UNLIMITED_VALUE = 1000000;

interface PlanFeatureProps {
  feature: string;
  value: number;
}

export const PlanFeature = ({ feature, value }: PlanFeatureProps) => {
  const resource: string = t(`settings.billing.${feature}`);
  const isUnlimited = value === UNLIMITED_VALUE;

  return (
    <FeatureCell>
      {isUnlimited ? (
        <>
          <StringFeature value={t("settings.billing.unlimited")} />
          {feature === planFeatures.max_member_count && (
            <TooltipIcon
              tooltipKey="settings.billing.unlimited_members_tooltip"
              tooltipProps={{ total: value, resource }}
            />
          )}
        </>
      ) : (
        <NumberFeature value={value} />
      )}
    </FeatureCell>
  );
};
